import { ADMIN_URL_DEFAULT, ZFP_API_URL_DEFAULT } from "./constants.ts";
import type { AnalyzerWindow, Config } from "./types";
declare const window: AnalyzerWindow;

const UNDEFINED = "UNDEFINED";

const config: Config = {
  zfpApiUrl: null,
  adminUrl: null,
  ssoClientId: null,
  hostUrl: `${window.location.protocol}//${window.location.host}`,
  env: null,
  branchName: null,
  commitMessage: null,
};

export const Configuration = {
  initConfig() {
    if (window?.config) {
      config.zfpApiUrl = window.config.zfpApiUrl ?? ZFP_API_URL_DEFAULT;
      config.adminUrl = window.config.adminUrl ?? ADMIN_URL_DEFAULT;
      config.env = window.config.env ?? null;
      config.branchName = window.config.branchName ?? null;
      config.commitMessage = window.config.commitMessage ?? null;
    } else {
      config.zfpApiUrl = ZFP_API_URL_DEFAULT;
      config.adminUrl = ADMIN_URL_DEFAULT;
    }
  },

  getApiUrlZfp() {
    return config.zfpApiUrl ?? ZFP_API_URL_DEFAULT;
  },

  getAdminUrl() {
    return config.adminUrl ?? ADMIN_URL_DEFAULT;
  },

  getHostUrl() {
    return config.hostUrl;
  },

  getIsProduction() {
    return config.env === "production";
  },

  getIsStaging() {
    return config.env?.includes("staging") ?? false;
  },

  getIsDev() {
    return config.env?.includes("dev") ?? false;
  },

  getIsLocalhost() {
    return window.location.hostname === "localhost";
  },

  getIsDevelopment() {
    return this.getIsStaging() || this.getIsLocalhost() || this.getIsDev();
  },

  getEnvName() {
    return this.getIsLocalhost() ? "localhost" : config.env;
  },

  getBranchName() {
    return config.branchName ?? UNDEFINED;
  },

  getCommitMessage() {
    return config.commitMessage ?? UNDEFINED;
  },
};
